import { render, staticRenderFns } from "./CreateReview.vue?vue&type=template&id=8111341c&scoped=true"
import script from "./CreateReview.vue?vue&type=script&lang=js"
export * from "./CreateReview.vue?vue&type=script&lang=js"
import style0 from "./CreateReview.vue?vue&type=style&index=0&id=8111341c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8111341c",
  null
  
)

export default component.exports